import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { DRAFT_STALE_TIME_MS } from "../constants";
import { isSegmentCountable } from "../mappers";

import { segmentsQueryKeys } from "@/features/segments/api/queryKeys";
import type { SegmentVacancyFiltersResponse } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

export type UseSegmentVacancyFiltersParams = Parameters<
  typeof segmentsQueryKeys.vacancyFilters
>[0] & { enabled: boolean };

export function useSegmentVacancyFilters({
  enabled,
  ...params
}: UseSegmentVacancyFiltersParams) {
  return useQuery<SegmentVacancyFiltersResponse, AxiosError>({
    queryKey: segmentsQueryKeys.vacancyFilters(params),
    queryFn: ({ signal }) =>
      instance
        .post<SegmentVacancyFiltersResponse>(
          "/api/v2/Segments/drafts/vacancies/filters",
          { ...params.body, list: params.list, search: params.search },
          { signal },
        )
        .then((res) => res.data),
    enabled: enabled && isSegmentCountable(params.body),
    staleTime: DRAFT_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
}
